module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#cancel",
      toString: function () {
        return this.url;
      }
    }